import {
    EUROPACE_PAYMENT_DATES,
    LOAN_REQUEST_CAR_FINANCING_WISHES,
    LOAN_REQUEST_CAR_TYPES,
    LOAN_REQUEST_CAR_VENDORS,
    LOAN_REQUEST_USAGES,
} from 'cpool-constants';
import { z } from 'zod';

import { schemaApplicantRSV } from './ApplicantRSV';
import { schemaDataSnippets } from './DataSnippets';
import { schemaBigDecimal, schemaInteger } from '../../utils/schema.utils';

// NOTE: this schema is used in the LoanRequest_OffersRequested and LoanRequest_EuropaceOffersRequest* events, so only add optional values here
export const schemaConditions = z.object({
    carFinance: z.optional(
        z.object({
            brand: z.optional(z.string()),
            downPayment: z.optional(z.number()),
            financingWish: z.optional(z.nativeEnum(LOAN_REQUEST_CAR_FINANCING_WISHES)),
            firstRegistration: z.optional(z.coerce.date()),
            mileage: z.optional(z.number()),
            model: z.optional(z.string()),
            performancekW: z.optional(z.number()),
            performancePS: z.optional(z.number()),
            vehiclePrice: z.optional(z.number()),
            vehicleType: z.optional(z.nativeEnum(LOAN_REQUEST_CAR_TYPES)),
            vendor: z.optional(z.nativeEnum(LOAN_REQUEST_CAR_VENDORS)),
        }),
    ),
    commissionRequestInPercent: z.optional(schemaBigDecimal),
    commissionResponseInPercent: z.optional(schemaBigDecimal),
    dataSnippets: z.optional(
        z.object({
            applicant1: z.optional(schemaDataSnippets),
            applicant2: z.optional(schemaDataSnippets),
        }),
    ),
    financingPurpose: z.optional(z.nativeEnum(LOAN_REQUEST_USAGES)),
    liabilityStates: z.optional(
        z.array(
            z.object({
                abloesen: z.boolean().optional(),
                hide: z.boolean().optional(),
                id: z.string(),
            }),
        ),
    ),
    paymentDate: z.optional(z.nativeEnum(EUROPACE_PAYMENT_DATES)),
    requestAmount: z.optional(schemaBigDecimal),
    residualDebtInsurance: z.optional(
        z.object({
            applicant1: z.optional(schemaApplicantRSV),
            applicant2: z.optional(schemaApplicantRSV),
        }),
    ),
    runtimeInMonths: z.optional(schemaInteger),
    totalFinancedAmount: z.optional(schemaBigDecimal),
});

export type SchemaConditions = z.infer<typeof schemaConditions>;
